import { numbersToStringWithCommas } from 'src/components/dashboard-pages/solve-insights/helpers';
import { AggregationType } from 'src/services/insight-cards/types';

/**
 * Format a numeric value from an AB test chart dataset for display.
 * Shared by AbTestMetricCard (conversations tab) and AbTestSummaryCards (homepage).
 */
export function formatAbTestValue(
  value: number,
  aggregationType: AggregationType | string,
  valueSuffix?: string | null,
): string {
  if (valueSuffix === '%') {
    return Math.round(value) + '%';
  }

  switch (aggregationType) {
    case 'formula':
    case 'conversion':
    case 'rate':
      return numbersToStringWithCommas({
        number: value,
        style: 'percent',
      });
    case 'avg':
      return numbersToStringWithCommas({
        canBeFloat: true,
        number: value,
      });
    default:
      return numbersToStringWithCommas({
        number: value,
      });
  }
}
